import { config } from '../config';

export class ApiError extends Error {
  constructor(
    message: string,
    public status?: number,
    public details?: Record<string, string>
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

async function fetchApi<T>(endpoint: string): Promise<T> {
  const url = `${config.apiUrl}${endpoint}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new ApiError(`API error: ${response.statusText}`, response.status);
    }

    const json = await response.json();
    return json as T;
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }

    throw new ApiError(error instanceof Error ? error.message : 'Network error', 0);
  }
}

export const api = {
  get: fetchApi,
};
